<template>
  <div>
    <v-row>
      <v-col cols="4">
        <GridRoluri @selection-changed="handleSelectionChanged" />
      </v-col>
      <v-col cols="8">
        <GridDrepturiRoluri v-if="selectedRow !== null && selectedRow !== undefined" :key="selectedRow"
          :rol-id="selectedRow" />

      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import GridDrepturiRoluri from './GridDrepturiRoluri.vue';
import GridRoluri from './GridRoluri.vue';

export default {
  name: 'PaginaUtilizatori',
  components: { GridDrepturiRoluri, GridRoluri },
  data() {
    return {
      selectedRow: null as number | null,
    };
  },
  methods: {
    handleSelectionChanged(row: any) {

      this.selectedRow = row?.ID ?? row?.id ?? null;
    },
  },
};
</script>
